export const AwardsLabelKey = [
  "components.userStatistics.goldAward",
  "components.userStatistics.silverAward",
  "components.userStatistics.bronzeAward",
];
